import { SupplierActivationStatus } from 'entities/Property/model/types/PropertySchema';

import type { TFunction } from 'i18next';

const getVendorProductOrderingStatusStyles = (status: string) => {
    switch (status) {
        case SupplierActivationStatus.Verified:
            return {
                backgroundColor: '#CBF4C9',
                color: '#4A8870',
            };
        case SupplierActivationStatus.ActionRequired:
            return {
                backgroundColor: 'rgba(255, 0, 0, 0.10)',
                color: '#FF0000',
            };
        case SupplierActivationStatus.Pending:
            return {
                backgroundColor: 'rgba(0, 0, 0, 0.10)',
                color: 'rgba(0, 0, 0, 0.50)',
            };
        default:
            return {
                backgroundColor: 'transparent',
                color: 'inherit',
            };
    }
};

const getVendorProductOrderingStatusText = (
    t: TFunction,
    status: string,
    defaultText: string = '',
) => {
    switch (status) {
        case SupplierActivationStatus.Verified:
            return t('Enabled');
        case SupplierActivationStatus.Pending:
            return t('Pending');
        case SupplierActivationStatus.ActionRequired:
            return t('Action required');
        default:
            return defaultText;
    }
};

export {
    getVendorProductOrderingStatusStyles,
    getVendorProductOrderingStatusText,
};
